"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Button = _interopRequireDefault(require("./buttons/Button"));
var _utils = require("../../utils");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
;
class Switch extends _Button.default {
  /**
   * Current value based on the switch selected state.
   *
   * @readonly
   * @type {*}
   * @memberof Switch
   */
  get value() {
    let value = this.opts.value;
    const {
      values
    } = this.opts;
    if (values) {
      values.forEach((v, index) => {
        if (this.selected && index === 1) {
          value = v.value || v;
        } else if (!this.selected && index === 0) {
          value = v.value || v;
        }
      });
    }
    return value;
  }
  /**
   * Initializes and returns a switch control instance with the specified configuration options.
   *
   * @param {*} [opts]
   * @memberof Switch
   */
  constructor(opts) {
    opts = (0, _utils.extend)({
      loader: false
    }, opts, {
      className: opts.className ? `ui-switch ${opts.className}` : 'ui-switch'
    });
    // normalize values array
    if (opts.values) {
      opts.values = opts.values.map(v => {
        if (!(0, _utils.isPlainObject)(v)) {
          return {
            label: v,
            value: v
          };
        }
        return v;
      });
    }
    super(opts);
  }
  _render(data) {
    const {
      label,
      values
    } = this.opts;
    const labels = {
      left: '',
      right: ''
    };
    if (values) {
      values.forEach((v, index) => {
        const key = index === 0 ? 'left' : 'right';
        let content = '';
        if ((0, _utils.isPlainObject)(v)) {
          content = v.label;
        } else {
          content = v;
        }
        labels[key] = `<div class="awxjs__ui-switch-label awxjs__ui-switch-label-${key}">${content}</div>`;
      });
    }
    return `
			<div class="awxjs__ui-switch">
				${label ? `<div class="awxjs__ui-switch-label">${label}</div>` : ''}
				${labels.left}
				<div class="awxjs__ui-switch__control">
					<div class="awxjs__ui-switch__control-indicator"></div>
				</div>
				${labels.right}
			</div>
		`;
  }
}
var _default = exports.default = Switch;
module.exports = exports.default;